module.exports = __webpack_public_path__ + "img/ico_vencedor.c9780c7c.png";